import { useContext } from "react";

import { RestaurantContext } from "../components/restaurant-provider";

export const useRestaurantContext = () => {
  return useContext(RestaurantContext);
};
